/* eslint-disable react/require-default-props */
import React from "react";
import icon from "../../img/footer_icon/tt-logo2.png";
import "./PdfPage.scss";

export default function PdfPage({ isHidden, children, breakPage }) {
  const breakExtra = breakPage ? "PdfPage pagebreak" : "PdfPage";

  const start = Date.now();

  const formatDateHead = (num) => {
    const d = new Date(num);
    let ye = new Intl.DateTimeFormat("en", { year: "numeric" }).format(d);
    const mo = new Intl.DateTimeFormat("en", { month: "short" }).format(d);
    const da = new Intl.DateTimeFormat("en", { day: "numeric" }).format(d);
    const newDate = `${da} ${mo}, ${ye}`;
    return newDate;
  };

  return (
    <div className={breakExtra}>
      {isHidden ? null : (
        <div className="page-stamp">
          <img src={icon} alt="total-icon" />
          <p className="">{formatDateHead(start)}</p>
        </div>
      )}
      {breakPage ? (
        <div className="page-content pagebreak">{children}</div>
      ) : (
        <div className="page-content">{children}</div>
      )}
    </div>
  );
}

PdfPage.defaultProps = {
  isHidden: false,
};
